module.exports = __webpack_public_path__ + "static/media/vehicle16.2e1c1a4c.svg";